/** §7 response shapes (camelCase JSON). */
/**
 * Sensitivity-redaction marker: a field the caller's role is not cleared to see
 * is replaced with this literal server-side (before the model/client receives
 * it) rather than dropped, so the answer can truthfully say "no autorizado"
 * instead of guessing. Mirrors the private marker in the API's redact step.
 */
export const REDACTED = '[REDACTADO]';
//# sourceMappingURL=api-types.js.map